<template>
  <div>
    <div class="space-y-3">
      <span class="text-text-neutral-tertiary text-xs">
        {{ t('passengerDataForm.citizenship') }}
      </span>
      <div class="space-y-2">
        <FreeButton
          type="button"
          class="bg-situational-lightgrey h-13 flex w-full justify-between border"
          :class="
            hasError
              ? 'border-background-negative-primary'
              : 'border-transparent'
          "
          @click="emit('openCitizenshipBottomSheet')"
        >
          <span class="truncate text-left text-base">
            {{ citizenshipText }}
          </span>
          <img
            src="../../../assets/images/chevron-arrow.svg"
            width="24"
            height="24"
            alt=""
          />
        </FreeButton>
        <p
          v-if="hasError && errorMessage"
          class="text-text-negative-primary text-xs"
        >
          {{ errorMessage }}
        </p>
      </div>
    </div>
    <CitizenshipBottomSheet
      class="top-auto h-screen"
      :name="citizenshipBottomSheetName"
      :selected-country-code="citizenship"
      @onCitizenshipSelect="emit('onCitizenshipSelect', $event)"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { FreeButton, CitizenshipBottomSheet } from 'freedom-shared';
  import { citizenshipEntity } from 'shared';
  import { useI18n } from 'vue-i18n';

  const props = defineProps<{
    citizenship: string;
    citizenshipBottomSheetName: string;
    hasError: boolean;
    errorMessage?: string;
  }>();

  const emit = defineEmits<{
    onCitizenshipSelect: [string];
    openCitizenshipBottomSheet: [];
  }>();

  const { t } = useI18n();

  const citizenshipText = computed(() =>
    citizenshipEntity.lib.getCountryNameByCode(props.citizenship),
  );
</script>

<i18n src="../config/locales.json"></i18n>
